/** @type {string} */
export const LOCAL_NEW_CHAT_ID = "__local-new__"
